import '../../src/stylesheets/blog/application';

require("@rails/ujs").start()

import '../../src/javascripts/blog/navigation';
